import watch from 'redux-watch';
import template from 'modal/request-swatch-confirmation.j2';
import { render } from '../../../core/js/components/coreComponent';
import { debug, info, error } from '../../../core/js/utils/logger';

import { generate } from '../../../core/js/utils/componentUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';

import { resetRequestSwatchFormData, resetRequestSwatchSelections } from '../actions/productActions';
import { resetGenericEmailSuccessState } from '../../../core/js/actions/genericEmailServiceActions';
import { handleUtagEvent } from '../../../core/js/actions/initialActions.js';

import { popAllModalTransition } from '../../../core/js/actions/modalActions';

function addRequestSwatchConfirmationPageViewTracking(store) {
    const requestSwatchUtagData = {
        page_id: `${store.getState().core.localizations.containers.analyticsContainer.product_request_swatch_confirmation_page_id}`,
        category_id: `${store.getState().core.localizations.containers.analyticsContainer.help_category_id}`
    };

    store.dispatch(handleUtagEvent(requestSwatchUtagData, 'view'));
}

function firstRender(store) {
    this.render(store, this);
    addRequestSwatchConfirmationPageViewTracking(store);
}

function afterCloseAction(store) {
    store.dispatch(resetRequestSwatchFormData());
    store.dispatch(resetRequestSwatchSelections());
    store.dispatch(resetGenericEmailSuccessState());
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-request-swatch-continue'), (e) => {
        e.preventDefault();
        const payload = popAllModalTransition(e, this.name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        firstRender: firstRender,
        template: template,
        name: 'modal.requestSwatchConfirmation',
        watch: 'product.productRequestSwatch',
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals
    };

    return generate(config, store, overrides);
}
